export enum PRODUCT_ENV {
    JDY = 'jdy',
    JODOO = 'jodoo',
    SELFHOSTED = 'selfhosted'
}
